import { ChevDownIcon, cn, MarkdownText, Text } from '@viapeople/components'
import { useState } from 'react'
import type { ComponentProps, InstructionsCustomProps } from './types'
import { getLabelVariant } from './utils'

export const FormsInstructions = ({ component }: ComponentProps) => {
	const {
		label,
		labelColor,
		labelSize,
		labelWeight,
		backgroundColor,
		text,
		textColor: _textColor,
	} = component.custom as InstructionsCustomProps
	const [isOpen, setIsOpen] = useState(true)

	const toggleOpen = () => {
		setIsOpen(!isOpen)
	}

	return (
		<button
			type='button'
			className={cn('w-full flex flex-col text-left cursor-pointer', backgroundColor && 'p-4 rounded-md')}
			style={{ backgroundColor: backgroundColor || undefined }}
			onClick={toggleOpen}>
			{label && (
				<div className={cn('flex items-center gap-2', isOpen && 'mb-1', labelWeight === 'hidden' && 'hidden')}>
					<Text
						variant={getLabelVariant(labelSize, 'h6')}
						weight={(labelWeight !== 'hidden' && labelWeight) || 'semibold'}
						style={{ color: labelColor }}>
						{label}
					</Text>
					<ChevDownIcon
						style={{
							fill: labelColor,
							transform: isOpen ? 'rotate(0deg)' : 'rotate(-180deg)',
							transition: 'transform 0.2s ease-in-out',
						}}
					/>
				</div>
			)}
			{text && (
				<div
					className={cn(
						'overflow-hidden transition-all duration-300 ease-in-out',
						isOpen ? 'max-h-[1999px] opacity-100' : 'max-h-0 opacity-0',
					)}>
					<MarkdownText markdown={text} variant='small' />
				</div>
			)}
		</button>
	)
}
